import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import "../css/landing.css";
import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import SplitText from "../components/uikit/SplitText";
import VariableProximity from "../components/uikit/VariableProximity";
import Magnet from "../components/uikit/Magnet";
import MagnetLines from "../components/uikit/MagnetLines";
import yash from "../assets/yash.jpg";
// import Background3D from "../components/Background3D";
// import "../css/landing.css";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
// import { useRef, useEffect, useState } from "react";
import c from "../assets/c.png";
import cplus from "../assets/c++.png";
import css from "../assets/css.png";
import dart from "../assets/dart.png";
import express from "../assets/express.png";
import flutter from "../assets/flutter.png";
import html from "../assets/html.png";
import java from "../assets/java.png";
import js from "../assets/js.png";
import mongo from "../assets/mongoDB.png";
import npm from "../assets/npm.png";
import os from "../assets/os.png";
import react1 from "../assets/react.png";
import ruby from "../assets/ruby.png";
import sql from "../assets/sql.png";
import ts from "../assets/ts.png";
import gsap from "gsap";
import SplitType from "split-type";
import revealAnimation from "../components/Reveal";
import { getMyAuth, getUserName, setMyAuth } from "../utils/helpers";
import Hyperspeed from "../components/uikit/Hyperspeed";
import TrueFocus from "../components/uikit/TrueFocus";
import InfiniteScroll from "../components/uikit/InfiniteScroll";
import Ballpit from "../components/uikit/Ballpit";
import BookmarkButton from "../components/BookmarkBtn";

const ShuffleHero = () => {
  const navigate = useNavigate();

  const base_url = process.env.REACT_APP_BASE_URL;

  const containerRef = useRef(null);

  const items = [
    { content: "Text Item 1" },
    { content: <p>Paragraph Item 2</p> },
    { content: "Text Item 3" },
    { content: <p>Paragraph Item 4</p> },
    { content: "Text Item 5" },
    { content: <p>Paragraph Item 6</p> },
    { content: "Text Item 7" },
    { content: <p>Paragraph Item 8</p> },
    { content: "Text Item 9" },
    { content: <p>Paragraph Item 10</p> },
    { content: "Text Item 11" },
    { content: <p>Paragraph Item 12</p> },
    { content: "Text Item 13" },
    { content: <p>Paragraph Item 14</p> },
  ];


  const handlebadge = () => {
    // Replace with the Instagram URL you want to navigate to
    const instagramUrl = "https://yash-chauhan.vercel.app";
    window.open(instagramUrl, "_blank"); // Opens the URL in a new tab
  };



  // const { user } = useKindeAuth/();
  const { login, register, user, isAuthenticated, logout } = useKindeAuth();

  useEffect(() => {
    //just to start server earier when user is on landing page
    const fetchData = async () => {
      const response = await fetch(`${base_url}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const contentType = response.headers.get("Content-Type");

      let data;
      if (contentType && contentType.includes("application/json")) {
        data = await response.json();
        console.log("JSON Data:", data);
      } else {
        data = await response.text();
      }
    };

    fetchData();
    const temp = getMyAuth();
    if (temp == null) {
      setMyAuth(isAuthenticated);
    }
    console.log(temp);
  }, [isAuthenticated]);

  const myAuth = getMyAuth() === "true";

  const username = getUserName();

  revealAnimation();
  // console.log(user);
  return (
    <>
      <nav className="navbar">
        <div className="lnav">
          <img src={logo} />
          <h1 className="reveal">Quick Labs</h1>
        </div>
        <div className="rnav">
        <BookmarkButton/>
          <div style={{ height: "100%", borderLeft: "1px solid white" }}>
            &nbsp;
          </div>
          {isAuthenticated ? (
            <button className="btn2" onClick={() => navigate("/auth/")}>
              👏&nbsp; Dashboard
            </button>
          ) : (
            <>
              <button className="btn2" onClick={login} type="button">
                &nbsp;&nbsp;Login&nbsp;&nbsp;
              </button>
            </>
          )}
        </div>
      </nav>

      <div className="main">
        <div className="hyperspeed">
          <Hyperspeed
            effectOptions={{
              onSpeedUp: () => {},
              onSlowDown: () => {},
              distortion: "turbulentDistortion",
              length: 400,
              roadWidth: 10,
              islandWidth: 2,
              lanesPerRoad: 4,
              fov: 90,
              fovSpeedUp: 150,
              speedUp: 2,
              carLightsFade: 0.4,
              totalSideLightSticks: 20,
              lightPairsPerRoadWay: 40,
              shoulderLinesWidthPercentage: 0.05,
              brokenLinesWidthPercentage: 0.1,
              brokenLinesLengthPercentage: 0.5,
              lightStickWidth: [0.12, 0.5],
              lightStickHeight: [1.3, 1.7],
              movingAwaySpeed: [60, 80],
              movingCloserSpeed: [-120, -160],
              carLightsLength: [400 * 0.03, 400 * 0.2],
              carLightsRadius: [0.05, 0.14],
              carWidthPercentage: [0.3, 0.5],
              carShiftX: [-0.8, 0.8],
              carFloorSeparation: [0, 5],
              colors: {
                roadColor: 0x080808,
                islandColor: 0x0a0a0a,
                background: 0x000000,
                shoulderLines: 0xffffff,
                brokenLines: 0xffffff,
                leftCars: [0xd856bf, 0x6750a2, 0xc247ac],
                rightCars: [0x03b3c3, 0x0e5ea5, 0x324555],
                sticks: 0x03b3c3,
              },
            }}
          />
        </div>

        {/* <SplitText
          text="Your Ultimate Last-Minute Learning Companion!"
          className="text-2xl font-semibold text-center main-heading"
          delay={50}
          animationFrom={{ opacity: 0, transform: "translate3d(0,50px,0)" }}
          animationTo={{ opacity: 1, transform: "translate3d(0,0,0)" }}
          easing="easeOutCubic"
          threshold={0.2}
          rootMargin="-50px"
        /> */}

        <div className="reveal main-text">
          Your Ultimate Last-Minute Learning Companion!
        </div>
        <div ref={containerRef} className="main-text2">
          <VariableProximity
            label={"Empower Your Learning, Elevate Your Success!"}
            className={"variable-proximity-demo"}
            fromFontVariationSettings="'wght' 400, 'opsz' 9"
            toFontVariationSettings="'wght' 1000, 'opsz' 40"
            containerRef={containerRef}
            radius={100}
            falloff="linear"
          />
          <br />
          <VariableProximity
            label={
              "At QuickLabs, we believe in turning pressure into performance."
            }
            className={"variable-proximity-demo"}
            fromFontVariationSettings="'wght' 400, 'opsz' 9"
            toFontVariationSettings="'wght' 1000, 'opsz' 40"
            containerRef={containerRef}
            radius={100}
            falloff="linear"
          />
          <br />
          <VariableProximity
            label={
              "Whether you're catching up or mastering concepts, we're here to make every moment count."
            }
            className={"variable-proximity-demo"}
            fromFontVariationSettings="'wght' 400, 'opsz' 9"
            toFontVariationSettings="'wght' 1000, 'opsz' 40"
            containerRef={containerRef}
            radius={100}
            falloff="linear"
          />
        </div>
        <Magnet padding={100} disabled={false} magnetStrength={10}>
          <button class="btn3" onClick={login}>
            <span class="text">get started</span>
          </button>
        </Magnet>

        <div className="yash-badge" onClick={handlebadge}>
          <Magnet padding={250} disabled={false} magnetStrength={10}>
            <h5>click</h5>
            <div className="yash-info">
              <div className="yash-avtar">
                <img src={yash} />
              </div>
              <h2>by yash chauhan</h2>
            </div>
          </Magnet>
        </div>

        <div className="click-wave">hold wave</div>
        {/* <div className="truefocus">
          <TrueFocus
            sentence="Code Projects SRS Asignments MCQ"
            manualMode={false}
            blurAmount={5}
            borderColor="red"
            animationDuration={1}
            pauseBetweenAnimations={0.4}
          />
        </div> */}
      </div>
      {/* <div className="main2">
        <div className="magnet-lines">
          <MagnetLines
            rows={6}
            columns={30}
            containerSize="30vmin"
            lineColor="#efefef"
            lineWidth="0.5vmin"
            lineHeight="4vmin"
            baseAngle={-10}
            style={{ margin: "1rem auto" }}
          />
        </div>
        <div style={{ height: "500px", positon: "relative" }}>
        <div style={{position: 'relative', overflow: 'hidden', minHeight: '500px', maxHeight: '500px', width: '100%'}}>
<Ballpit
  count={200}
  gravity={0.7}
  friction={0.8}
  wallBounce={0.95}
  followCursor={true}
/>
</div>
    <InfiniteScroll
    items={items}
    isTilted={true}
    tiltDirection='left'
    autoplay={true}
    autoplaySpeed={0.1}
    autoplayDirection="down"
    pauseOnHover={true}
  /> 
        </div>
      </div> */}
      {/* <section className="shuffle-hero">
        <div className="text-content">
          <h3 className="heading">
            From <span className="Confusion">Confusion</span>
            <br /> to <span className="Clarity">Clarity</span>
          </h3>
          <p className="description reveal">
            Ultimate Study Resources and Lab Solutions for Students!
          </p>
        </div>
        <button className="btn2" onClick={login} type="button">
          &nbsp;&nbsp;Get Started&nbsp;&nbsp;
        </button>
        <ShuffleGrid />
      </section> */}
    </>
  );
};

// const shuffle = (array) => {
//   let currentIndex = array.length,
//     randomIndex;

//   while (currentIndex !== 0) {
//     randomIndex = Math.floor(Math.random() * currentIndex);
//     currentIndex--;

//     [array[currentIndex], array[randomIndex]] = [
//       array[randomIndex],
//       array[currentIndex],
//     ];
//   }

//   return array;
// };

// const squareData = [
//   {
//     id: 1,
//     src: c,
//   },
//   {
//     id: 2,
//     src: cplus,
//   },
//   {
//     id: 3,
//     src: css,
//   },
//   {
//     id: 4,
//     src: dart,
//   },
//   {
//     id: 5,
//     src: express,
//   },
//   {
//     id: 6,
//     src: flutter,
//   },
//   {
//     id: 7,
//     src: html,
//   },
//   {
//     id: 8,
//     src: java,
//   },
//   {
//     id: 9,
//     src: js,
//   },
//   {
//     id: 10,
//     src: mongo,
//   },
//   {
//     id: 11,
//     src: npm,
//   },
//   {
//     id: 12,
//     src: os,
//   },
//   {
//     id: 13,
//     src: react1,
//   },
//   {
//     id: 14,
//     src: ruby,
//   },
//   {
//     id: 15,
//     src: sql,
//   },
//   {
//     id: 16,
//     src: ts,
//   },
// ];

// const generateSquares = () => {
//   return shuffle(squareData).map((sq) => (
//     <motion.div
//       key={sq.id}
//       layout
//       transition={{ duration: 1.5, type: "spring" }}
//       className="square"
//       style={{
//         backgroundImage: `url(${sq.src})`,
//       }}
//     ></motion.div>
//   ));
// };

// const ShuffleGrid = () => {
//   const timeoutRef = useRef(null);
//   const [squares, setSquares] = useState(generateSquares());

//   useEffect(() => {
//     shuffleSquares();

//     return () => clearTimeout(timeoutRef.current);
//   }, []);

//   const shuffleSquares = () => {
//     setSquares(generateSquares());

//     timeoutRef.current = setTimeout(shuffleSquares, 3000);
//   };

//   return <div className="shuffle-grid">{squares}</div>;
// };

export default ShuffleHero;
